var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0.25H1.125C0.492188 0.25 0 0.765625 0 1.375V2.875C0 3.08594 0.164062 3.25 0.375 3.25H0.75V9.625C0.75 10.2578 1.24219 10.75 1.875 10.75H10.125C10.7344 10.75 11.25 10.2578 11.25 9.625V3.25H11.625C11.8125 3.25 12 3.08594 12 2.875V1.375C12 0.765625 11.4844 0.25 10.875 0.25ZM10.5 9.625C10.5 9.83594 10.3125 10 10.125 10H1.875C1.66406 10 1.5 9.83594 1.5 9.625V3.25H10.5V9.625ZM11.25 2.5H0.75V1.375C0.75 1.1875 0.914062 1 1.125 1H10.875C11.0625 1 11.25 1.1875 11.25 1.375V2.5ZM4.78125 5.5H7.21875C7.35938 5.5 7.5 5.38281 7.5 5.21875V5.03125C7.5 4.89062 7.35938 4.75 7.21875 4.75H4.78125C4.61719 4.75 4.5 4.89062 4.5 5.03125V5.21875C4.5 5.38281 4.61719 5.5 4.78125 5.5Z",
    fill: "#486175",
    className: "fill-primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArchive);
export default __webpack_public_path__ + "static/media/ico-archive.24ff88d4226d7a1867cb352d324a4448.svg";
export { ForwardRef as ReactComponent };